import { ReactNode } from "react";
import palette from "../theme/palette";

const { primary: { main: primaryMain } } = palette;

export const withTrademarkTM = (text: ReactNode): ReactNode => {
  if (typeof text !== 'string') return text;
  const tokens = text.split(/(855|™)/);
  if (tokens.length === 1) return text;
  return (
    <>
      {tokens.map((token, i) => {
        if (token === '855') return <span key={i} style={{ color: primaryMain }}>855</span>;
        if (token === '™') return <span key={i} style={{ fontSize: '0.55em', position: 'relative', top: '-0.4em' }}>TM</span>;
        return token || null;
      })}
    </>
  );
};

export const withTrademark = (text: ReactNode): ReactNode => {
  if (typeof text !== 'string') return text;
  const tokens = text.split(/(855|™|any phone)/);
  if (tokens.length === 1) return text;
  return (
    <>
      {tokens.map((token, i) => {
        if (token === '855') return <span key={i} style={{ color: primaryMain }}>855</span>;
        if (token === '™') return <sup key={i}>™</sup>;
        if (token === 'any phone') return <span key={i} style={{ fontWeight: 'bold', color: 'black' }}>any phone</span>;
        return token || null;
      })}
    </>
  );
};
